import type { ReactNode } from "react";

export interface CardProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  /** Body padding (default true). */
  padded?: boolean;
  className?: string;
  id?: string;
}

export function Card({ title, description, actions, footer, children, padded = true, className, id }: CardProps): React.JSX.Element {
  return (
    <section className={`nb-card${className ? ` ${className}` : ""}`} id={id}>
      {title ? <CardHead title={title} description={description} actions={actions} /> : null}
      {padded ? <div className="nb-card-body">{children}</div> : children}
      {footer ? <footer className="nb-card-foot">{footer}</footer> : null}
    </section>
  );
}

function CardHead({ title, description, actions }: Pick<CardProps, "title" | "description" | "actions">): React.JSX.Element {
  return (
    <header className="nb-card-head">
      <div>
        <h3 className="nb-card-title">{title}</h3>
        {description ? <p className="nb-card-desc">{description}</p> : null}
      </div>
      {actions}
    </header>
  );
}
